import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

function Close() {
  return (
    <Svg width={48} height={48} viewBox="0 0 48 48" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 16l-2-2-8 8-8-8-2 2 8 8-8 8 2 2 8-8 8 8 2-2-8-8 8-8z"
        fill="#707070"
      />
    </Svg>
  );
}

export default Close;
